import React from 'react'
import './Footer.css'
import Wave from '../../img/wave.png'
import Insta from '@iconscout/react-unicons/icons/uil-instagram'
import Facebook from '@iconscout/react-unicons/icons/uil-facebook'
import Github from '@iconscout/react-unicons/icons/uil-github'
import LinkedIn from '@iconscout/react-unicons/icons/uil-linkedin'
const Footer = () => {
  return (
    <div className="footer">
        <img src={Wave} style={{width:'100%'}} alt="" />
        <div className="f-content">
            <span>Copyright © Akash 2023 </span>
            <div className="f-icons">
                <a href='https://www.instagram.com/' target={'_blank'} > <Insta color='white' size='3rem' /> </a> 
                <a href='https://www.facebook.com/' target={'_blank'} > <Facebook color='white' size='3rem' /> </a> 
                <a href='https://github.com/akash701752' target={'_blank'} > <Github color='white' size='3rem' /> </a> 
                <a href='https://www.linkedin.com/in/akash7017/' target={'_blank'} > <LinkedIn color='white' size='3rem' /> </a> 
            </div>
        </div>
    </div>
  )
}

export default Footer